// A hold on a node's updates (node updatehold.go, DECISIONS 2026-10-17
// "nodes behind central"): who held it, until when, and why.
import type { UpdateHold } from './api'
import { dateTime } from './util'

// held: whether the hold holds at now (one past its until lapses on the node
// within a second, and the page follows)
export const held = (h: UpdateHold | undefined | null, now = Date.now()): h is UpdateHold =>
    !!h && (!h.until || Date.parse(h.until) > now)

// holdText: "held by ops@… since … until …: the final"
export function holdText(h: UpdateHold): string {
    return `held by ${h.by} since ${dateTime(h.since)}${h.until ? `, until ${dateTime(h.until)}` : ''}${h.note ? `: ${h.note}` : ''}`
}
